export const avangaEncodeURI = uri => uri.replace(/\s/g, '-')
  .replace(/\u00e4/g, 'Ae')
  .replace(/\u00e4/g, 'ae')
  .replace(/\u00d6/g, 'Oe')
  .replace(/\u00f6/g, 'oe')
  .replace(/\u00dc/g, 'Ue')
  .replace(/\u00fc/g, 'ue')
  .replace(/\u00df/g, 'ss')
  .replace('?', '')
  .replace(':', '')
  .replace("'", '')
  .toLowerCase();

export const valideCSSName = string => string.replace(/[!\"#$%&'\(\)\*\+,\.\/:;<=>\?\@\[\\\]\^`\{\|\}~]/g, '').toLowerCase();



// WEBPACK FOOTER //
// ./src/sections/helpers.js